import { useKeycloak } from '@react-keycloak/web';
import { jwtDecode } from 'jwt-decode';

export const useUser = (): Partial<UserSessionJWT> | null => {
  const { keycloak } = useKeycloak();
  const { token } = keycloak;

  if (!token) return null;

  try {
    const decoded = jwtDecode<UserSessionJWT>(token);
    
    return {
      id: decoded.sid,
      sid: decoded.sid,
      email_verified: decoded.email_verified,
      name: decoded.name,
      preferred_username: decoded.preferred_username,
      given_name: decoded.given_name,
      family_name: decoded.family_name,
      email: decoded.email,
    };
  } catch (error) {
    console.error('Error decoding token:', error);
    return {
        id: '',
        email_verified: false,
        name: '',
        preferred_username: '',
        given_name: '',
        family_name: '',
        email: '',
    };
  }
};